import {
  ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter, map, startWith, switchMap, takeUntil } from 'rxjs/operators';

import { WithChangesSubject } from 'core/mixins/with-changes-subject';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { AddOrUpdateNameDialog } from 'entity/dialogs/add-or-update-name/add-or-update-name.dialog';

import { EntityCore, EntityWithBasicInfo, GetEntityById2GQL } from 'generated/graphql';

@Component({
  selector: 'app-entity-name-table',
  templateUrl: './entity-name-table.component.html'
})
export class EntityNameTableComponent
  extends WithDisposableSubject(WithChangesSubject(class {}))
  implements OnChanges, OnInit {
  @Input() entityId: string;
  @Input() campaignId: string;
  @Input() showTaskDoneMark = false;
  @Input() title = 'Name';

  entity: EntityCore.Fragment & EntityWithBasicInfo.Fragment = null;

  constructor(
    private _getEntityGQL: GetEntityById2GQL,
    private _cd: ChangeDetectorRef,
    private _dialog: MatDialog,
  ) {
    super();

  }

  ngOnInit() {
    this.watchForChangeKeys('entityId', 'campaignId').pipe(
      startWith<any, any>(null),
      takeUntil(this.disposer),
      map(() => ({ campaignId: this.campaignId, entityId: this.entityId })),
      filter(({ campaignId, entityId }) => !!campaignId || !!entityId),
      switchMap(({ campaignId, entityId }) => this._getEntityGQL.watch({
        entityId,
        campaignId,
        // withToplines: true,
        // withBestAddress: false,
        // withBestEmail: false,
        // withBestPhone: false
      }, {
        fetchPolicy: 'cache-first'
      }).valueChanges.pipe(takeUntil(this.disposer))),
      map(({ data }) => data?.getEntity)
    ).subscribe((entity) => {
      this.entity = entity as any;
      this._cd.markForCheck();
    });
  }

  openEditNameDialog() {
    AddOrUpdateNameDialog.open(this._dialog, {
      data: {
        entityId: this.entityId,
        campaignId: this.campaignId
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}
